/**
 * Gets the state of an application to a job listing.
 * @param {Object} state the application state
 * @param {String|Number} jobListingId the ID for the job listing.
 * @return {Map} the state for the applicationwith the jobListingId provided, if found.
 */
export default (state, jobListingId) =>
  state.applicationSubmissions.get(String(jobListingId));
